// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"653e90f7","598":"f8e4cc47","703":"fab6ac5c","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};